let routes = [
  {
    path: '/demande-reinscription-psychologue',
    component: () => import('../views/DemandeReinscriptionPsychologue.vue'),
    props: true
  },
  {
    path: '/demande-reinscription-psychologue/:step',
    component: () => import('../views/DemandeReinscriptionPsychologue.vue'),
    props: true
  }
]

export default routes;